import { useState } from 'react';
import { Dialog } from '../../../entry-form-v2/component/Dialog';
import { IconButton } from '../../../entry-form-v2/component/IconButton';
import { History } from 'lucide-react';
import { Tooltip } from '../display/Tooltip';
import { LanguageType } from '../../../../types';
import { useLanguage } from '../../../hooks/useLanguage';
import clsx from 'clsx';
import { ChangeHistoryTab } from './ChangeHistoryTab';
import { AccessHistoryTab } from './AccessHistoryTab';

export const CodelistHistoryModalButton = ({
	originalEntryId,
	codelistRecordId
}: {
	originalEntryId: string;
	codelistRecordId: string;
}) => {
	const [open, setOpen] = useState(false);
	const [activeTab, setActiveTab] = useState<'changes' | 'access'>('changes');

	const language = useLanguage();
	const translation = DICTIONARY[language];

	return (
		<>
			<Tooltip content={translation.tooltip}>
				<IconButton onClick={() => setOpen(true)}>
					<History className="size-6" />
				</IconButton>
			</Tooltip>

			<Dialog title={translation.title} open={open} onClose={() => setOpen(false)}>
				<div className="w-[600px]">
					<p className="text-sm text-gray-900 mb-4">Record ID: {codelistRecordId}</p>
					<div className="flex gap-2 mb-4">
						<TabButton
							active={activeTab === 'changes'}
							onClick={() => setActiveTab('changes')}
						>
							{translation.changesTab}
						</TabButton>
						<TabButton
							active={activeTab === 'access'}
							onClick={() => setActiveTab('access')}
						>
							{translation.accessTab}
						</TabButton>
					</div>

					{activeTab === 'changes' && (
						<ChangeHistoryTab originalEntryId={originalEntryId} />
					)}
					{activeTab === 'access' && (
						<AccessHistoryTab originalEntryId={originalEntryId} />
					)}
				</div>
			</Dialog>
		</>
	);
};

const TabButton = ({
	children,
	onClick,
	active
}: {
	children: React.ReactNode;
	onClick: () => void;
	active: boolean;
}) => {
	return (
		<button
			className={clsx('text-base p-2 text-gray-900 border-b-2 hover:bg-primary-500/10', {
				'border-gray-900': active,
				'border-transparent': !active
			})}
			onClick={onClick}
		>
			{children}
		</button>
	);
};

const DICTIONARY = {
	[LanguageType.English]: {
		tooltip: 'History',
		title: 'Codelist history',
		changesTab: 'Changes',
		accessTab: 'Access'
	},
	[LanguageType.Norwegian]: {
		tooltip: 'Historikk',
		title: 'Kodelistehistorikk',
		changesTab: 'Endringer',
		accessTab: 'Tilgang'
	}
};
